import { createFileRoute } from '@tanstack/react-router';
import { TargetsPanel } from '@/components/organisms/analytics-reports';

export const Route = createFileRoute('/_dashboard/dashboard/reporting/targets')({
  component: ReportingTargetsPage,
});

function ReportingTargetsPage() {
  return <TargetsPanel reportingPage />;
}
